import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  className?: string;
  actions?: ReactNode;
};

const PageHeader = ({ title, subtitle, className, actions }: PageHeaderProps) => (
  <div
    className={cn("flex flex-col gap-4 md:flex-row md:items-center md:justify-between", className)}
  >
    <div className="flex flex-col gap-1">
      <h1 className="text-3xl font-bold tracking-tight text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
